import { SvgIcon, SvgIconProps } from '@material-ui/core';
import { MONGODB_PATHS } from './paths';

/** Лист MongoDB, контур из Simple Icons (CC0). */
export const MongodbIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {MONGODB_PATHS.map(d => (
      <path key={d} d={d} />
    ))}
  </SvgIcon>
);
